import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import LazyImage from './LazyImage';

const LandingCard = (props) => {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);
    const cardRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                        observer.disconnect();
                    }
                });
            },
            {
                rootMargin: '100px',
                threshold: 0.1
            }
        );

        const currentRef = cardRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, []);

    return (
        <div
            ref={cardRef}
            style={{ 
                backgroundColor: props.color, 
                minHeight: '40rem', 
                float: props.float,
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
                transition: 'opacity 0.6s ease-out, transform 0.6s ease-out'
            }}
            className={`landing-card justify-content-center
            container ${props.align ? 'fl-row' : null}`}
        >
            <div className={`d-flex gap-4 flex-column`}>
                <h2 style={{ textTransform: 'uppercase', fontSize: '1.75rem', lineHeight: '1.3' }}>
                    {t(props.title)}
                </h2>
                <h1 style={{ color: '#120651', fontSize: '2.25rem', lineHeight: '1.2', fontWeight: '600' }}>{t(props.slogan)}</h1>
                <p style={{ fontStyle: 'italic', fontSize: '1.25rem', lineHeight: '1.6', color: '#555' }}>{t(props.description)}</p>
                <button
                    style={{
                        padding: '.75rem 1rem',
                        width: '100%',
                        maxWidth: '17.5rem',
                        minHeight: '48px',
                        border: '3.5px solid #FFDEF3',
                        borderRadius: '.5rem',
                        backgroundColor: '#FFDEF3',
                        cursor: 'pointer',
                        touchAction: 'manipulation',
                        fontSize: '1rem',
                        transition: 'all 0.2s ease',
                        fontWeight: '500'
                    }}
                    onMouseEnter={(e) => {
                        if (window.matchMedia('(hover: hover)').matches) {
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(255, 222, 243, 0.4)';
                        }
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = '';
                        e.currentTarget.style.boxShadow = '';
                    }}
                >
                    <Link
                        style={{
                            color: 'black',
                            backgroundColor: '#FFDEF3 !important',
                            display: 'block',
                            textDecoration: 'none',
                            width: '100%'
                        }}
                        to={`/${props.link}`}
                    >
                        {t(props.button)}
                    </Link>
                </button>
            </div>
            <div
                className={`d-flex justify-content-center align-items-center ${
                    props.align ? 'float-left' : ''
                }`}
            >
                {props.img ? (
                    <LazyImage 
                        src={props.img} 
                        alt={props.title} 
                        className="landing-img"
                        placeholder="#f5f5f5"
                    />
                ) : null}
            </div>
        </div>
    );
};

export default LandingCard;
